export default "/images/dcf95dcf7632f7c3e470356d9537504e.avif";